import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Box, Paper, Tab, Tabs, WithStyles } from "@material-ui/core";
import { styles } from "./StatsView.styles";
import UniversalTable from "../../../components/UniversalTable/UniversalTable";
import { IUniversalTableData } from "../../../components/UniversalTable/interfaces";
import { today } from "../../../../utilities/dateTimeUtils";
import { CsvExportButton, IColumnMapping } from "../../../components/CsvExport/CsvExportButton";

const tabs = [
    {
        title: "Summary",
        field: "general",
        columns: "summaryColumns"
    },
    {
        title: "Data",
        field: "binaries",
        columns: "dataColumns"
    }
];

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`download-centre-tabpanel-${index}`}
            aria-labelledby={`download-centre-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={0}>{children}</Box>}
        </div>
    );
}

export interface IStatsTableProps extends WithStyles<typeof styles> {
    dataColumns: any[];
    summaryColumns: any[];
    summaryData: IUniversalTableData;
    data: IUniversalTableData;
    exportFilePrefix: string;
    dataExportMapping: IColumnMapping[];
    summaryDataExportMapping: IColumnMapping[];
}

const StatsTablePure: React.FunctionComponent<IStatsTableProps> = ({
    dataColumns,
    summaryColumns,
    data,
    summaryData,
    exportFilePrefix,
    dataExportMapping,
    summaryDataExportMapping,
    classes
}: IStatsTableProps) => {
    
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const isSummarySelected = value === 0;
    const dataForExport = isSummarySelected ? summaryData : data

    return (
        <div>
            <CsvExportButton
                    data={dataForExport || []}
                    outputFilename={`${exportFilePrefix}_${isSummarySelected ? "_summary" : ""}_${today().format("YYYYMMDD")}.csv`}
                    mappings={isSummarySelected ? summaryDataExportMapping : dataExportMapping}
                >
                    Export data
                </CsvExportButton>
        
        <Paper square className={classes.statsTableSection}>
            <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleChange}>
                {tabs.map((tab, index) => (
                    <Tab key={index} label={tab.title} />
                ))}
            </Tabs>
            <TabPanel value={value} key={0} index={0}>
                <UniversalTable columns={summaryColumns} data={summaryData} searchable />
            </TabPanel>
            <TabPanel value={value} key={1} index={1}>
                <UniversalTable columns={dataColumns} data={data} searchable />
            </TabPanel>
        </Paper>
        </div>
    );
};

export const StatsTable = withStyles(styles)(StatsTablePure);
